/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3 3H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 21L21 16M16 21L11 16M16 21V9.4C16 7.15979 16 6.03968 15.564 5.18404C15.1805 4.43139 14.5686 3.81947 13.816 3.43597C12.9603 3 11.8402 3 9.6 3H9.5H9"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M16 21L21 16M16 21L11 16M16 21V9.4C16 7.15979 16 6.03968 15.564 5.18404C15.1805 4.43139 14.5686 3.81947 13.816 3.43597C12.9603 3 11.8402 3 9.6 3H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M16 21L21 16M16 21L11 16M16 21V9.4C16 7.15979 16 6.03968 15.564 5.18404C15.1805 4.43139 14.5686 3.81947 13.816 3.43597C12.9603 3 11.8402 3 9.6 3H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M21 16L16 21V9.4C16 7.15979 16 6.03968 15.564 5.18404C15.1805 4.43139 14.5686 3.81947 13.816 3.43597C12.9603 3 11.8402 3 9.6 3H3M11 16L13.5 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 21L21 16M16 21L11 16M16 21V9.4C16 7.15979 16 6.03968 15.564 5.18404C15.1805 4.43139 14.5686 3.81947 13.816 3.43597C12.9603 3 11.8402 3 9.6 3H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M16 21L21 16M16 21L11 16M16 21V9.4C16 7.15979 16 6.03968 15.564 5.18404C15.1805 4.43139 14.5686 3.81947 13.816 3.43597C12.9603 3 11.8402 3 9.6 3H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
